import { useReducedMotion } from 'framer-motion';
import type { Transition } from 'framer-motion';

export { useReducedMotion };

export const DURATION_FAST = 0.15;
export const DURATION_NORMAL = 0.2;
export const DURATION_SLOW = 0.3;

export const EASE_IN: [number, number, number, number] = [0.7, 0, 0.84, 0];
export const EASE_OUT: [number, number, number, number] = [0.16, 1, 0.3, 1];
export const EASE_IN_OUT: [number, number, number, number] = [0.4, 0, 0.2, 1];

export const SPRING_SNAPPY: Transition = {
  type: 'spring',
  stiffness: 500,
  damping: 25,
};

export function reduceMotion(
  prefersReduced: boolean | null,
  transition: Transition,
): Transition {
  if (prefersReduced) return { duration: 0 };
  return transition;
}
